import type { IconType } from "react-icons";
import { BsGoogle, BsMicrosoft } from "react-icons/bs";
import { SiOkta } from "react-icons/si";
import type { LoginProvider } from "state/members/member";

export type LoginProviderOption = {
  id: LoginProvider;
  name: string;
  icon: IconType;
};

// Display order on the login screen (and the sign-in-again prompt), whatever
// order the org stored them in.
export const LOGIN_PROVIDERS: LoginProviderOption[] = [
  { id: "google", name: "Google", icon: BsGoogle },
  { id: "microsoft", name: "Microsoft", icon: BsMicrosoft },
  { id: "okta", name: "Okta", icon: SiOkta },
];

export const offeredProviders = (available: string[] = []) =>
  LOGIN_PROVIDERS.filter((provider) => available.includes(provider.id));

const joinWithOr = (names: string[]) =>
  names.length < 2
    ? names.join("")
    : `${names.slice(0, -1).join(", ")} or ${names[names.length - 1]}`;

/** "Login with your Google, Microsoft or Okta account", for the options offered. */
export const loginHeading = (available: string[] = []) => {
  const names = offeredProviders(available).map((provider) => provider.name);

  return names.length === 0
    ? "Login with your account"
    : `Login with your ${joinWithOr(names)} account`;
};

/**
 * The provider a link asked to sign in with (`?auth=microsoft`), if the org
 * offers it. Anything else is ignored and the usual buttons are shown.
 */
export const requestedProvider = (
  requested: string | null,
  available: string[] = [],
): LoginProvider | null =>
  offeredProviders(available).find(
    (provider) => provider.id === requested?.toLowerCase(),
  )?.id ?? null;
